import React, { useMemo, useState, useRef  ,useEffect, useReducer, fetchData} from 'react';
import { Alert, Button, Container, Card, Table, Modal, Accordion,Form, FormLabel, Col, Row } from 'react-bootstrap';
import { useNavigate } from "react-router";

import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import useBackend, {XLogOff, IsLoggedIn, Loading, SpinnerX, CallDownload} from '../../services/useBackend_v2';
import MaterialReactTable from 'material-react-table';
import {getOptions} from '../../services/misc';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { FaFilePdf, FaReceipt, FaEnvelope,FaBars, FaUser, FaFileDownload, FaDownload } from 'react-icons/fa';

import download from 'downloadjs'
import { Link } from 'react-router-dom';

function SellReport() {

    const {loading, data, Refresh, Seek, initReady, XCall} =  useBackend('/api/reports');

    const [resultVariant, setResultVariant] = useState(null);
    const [resultText,    setResultText]    = useState(null);
    const [resultVisible, setResultVisible] = useState(null);
    const [reportVisible, setReportVisible] = useState(false);

    const [headline, setHeadline] = useState("Rapporter");



    const [reportData, setReportData] = useState(null);
    const [reportColumns, setReportColumns] = useState([]);

        const navigate = useNavigate();

    async function setReportHandler(e) {
        e.preventDefault();

        let type = e.currentTarget.getAttribute("type");
        let dataPath = e.currentTarget.getAttribute("dataPath");

        setHeadline(e.currentTarget.getAttribute("name"));

        if (type=="standardgrid") {
            var {errorsException, jsondata} =  await XCall (dataPath, "GET", 3000, {}, true);
                        
            let columnsnew = [];                                
            setReportData(jsondata[jsondata.datasetName]);
            var keys = Object.keys(jsondata[jsondata.datasetName][0]);
            keys.map((f) => columnsnew.push({ size: 10, accessorKey: f,  header: f, enableColumnActions: false }));

            setReportColumns(columnsnew);
            setReportVisible(true);
        }

        if (type=="link") {
            navigate(e.currentTarget.getAttribute("path"));
        }        

        if (type=="download") {
            handleExportData(e.currentTarget.getAttribute("filename"), e.currentTarget.getAttribute("path"));
        }    
    }

    async function handleExportData(filename, path) {        
        setResultVisible(true);
        setResultText("Påbörjar nedladdning...");
        setResultVariant("info");
        const csv = await CallDownload(path);
        download(csv, filename, 'text/csv')

        setResultText("Nedladdning klar!");

        setTimeout(() => {
            setResultVisible(false);
        }, 3000);     
    };  

    const initialState={
             density: 'compact',
    pagination: {
      pageIndex: 0,
      pageSize: 100,
    }
}
    
    const state = {  };  

    if (initReady) {
        return (
                <ContentWrapper>
                <Container>
                    <Sida>
                        <Rubrik>{headline}</Rubrik>

                        {(!loading && !reportVisible) && (<>
                            <ul>
                                {data.reportList.map((p) => (<li>
                                    {/* {p.isDownload===true && 
                                        <a className="text-decoration-none" style={{color:'#000', fontSize:'20px'}}  onClick={() => {handleExportData(p.filename, p.path)}}>{p.name} </a>}

                                    {p.isDownload===true && 
                                        <a className="text-decoration-none" style={{color:'#000', fontSize:'20px'}}  onClick={() => {handleExportData(p.filename, p.path)}}>{p.name} </a>}

                                    : */}
                                        <>
                                            <a className="text-decoration-none" style={{color:'#000', fontSize:'20px'}} onClick={setReportHandler} name={p.name} filename={p.filename} path={p.path} type={p.type} dataPath={p.data}><b>{p.name}</b></a><br></br>
                                            <small>{p.description}</small>
                                        </>
                                    
                                </li>))}
                            </ul>
                        </>)}

                        {(reportVisible) && (<>
                        <MaterialReactTable 
                            //enableColumnActions= {false}
                            columns={reportColumns}
                            data={reportData}
                            //rowCount= {data.totalNumOfRows}

                            // manualPagination= {true}
                            // onPaginationChange={setPagination} 
                            // paginationDisplayMode='pages'
                            
                            // muiSearchTextFieldProps = {{ placeholder: 'Sök på namn...' }}
                            // enableGlobalFilter = {true} // Visa sökruta
					        // manualFiltering = {true}  // Stänger av klientfiltrering
                            // onGlobalFilterChange={(search) => setSearchFilter(search, 750)}

                            // muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                            // muiTablePaginationProps={{ showFirstButton: true, showLastButton: true ,labelRowsPerPage:"Rader", rowsPerPageOptions: [25, 50, 100]}}
                            state={state}
                            initialState={initialState}
                            // renderTopToolbarCustomActions={() => (<Rubrik>Besök</Rubrik>)} 

                        /> 
                        </>)}                        
                        <Alert show={resultVisible} variant={resultVariant} className="FormSpace">{resultText}</Alert>
                    </Sida>
                </Container>
            </ContentWrapper>        
        )
    } else {
        return (<Loading />);        
    }
}

export default SellReport;